import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { X, User } from "react-feather";
import { styles } from "./style";

interface Props extends WithStyles<typeof styles> {
	open: boolean;
	onClose: () => void;
	title: string;
	leadName?: string;
	actions?: React.ReactNode;
	children: React.ReactNode;
}

const Component: React.FC<Props> = ({ classes = {}, open, onClose, title, leadName, actions, children }) => {
	return (
		<Mui.Dialog
			open={open}
			onClose={(event, reason) => {
				if (reason === "backdropClick") return;
				onClose();
			}}
			maxWidth={false}
			TransitionComponent={undefined}
			BackdropProps={{ className: classes.backdrop }}
			classes={{ paper: classes.paper }}
		>
			<div className={classes.header}>
				<div className={classes.headerLeft}>
					<Mui.Typography variant="h4" component="h2" className={classes.title}>
						{title}
					</Mui.Typography>
					{leadName && (
						<Mui.Chip
							size="small"
							icon={<User size={14} />}
							label={leadName}
							className={classes.leadTag}
						/>
					)}
				</div>
				<Mui.IconButton onClick={onClose} size="small">
					<X size={20} />
				</Mui.IconButton>
			</div>
			<div className={classes.content}>
				<div className={classes.contentInner}>
					{children}
				</div>
			</div>
			{actions && (
				<div className={classes.actions}>
					{actions}
				</div>
			)}
		</Mui.Dialog>
	);
};

export const FullPageModal = withStyles(Component, styles);
